function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgexport9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "svg-inline--fa fa-user-tie mr-icon-svg",
    style: {
      color: "white"
    },
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fal",
    "data-icon": "user-tie",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    "data-v-7c8d09eb": "",
    width: 448,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "",
    style: {},
    fill: "#FFFFFF",
    d: "M96 128C96 57.31 153.3 0 224 0C294.7 0 352 57.31 352 128C352 198.7 294.7 256 224 256C153.3 256 96 198.7 96 128zM320 128C320 74.98 277 32 224 32C170.1 32 128 74.98 128 128C128 181 170.1 224 224 224C277 224 320 181 320 128zM256 304C264.8 304 272 311.2 272 320C272 328.8 264.8 336 256 336H246.2L266.1 395.8L303.6 320.9C384.7 329.3 448 397.9 448 481.3C448 498.2 434.2 511.1 417.3 511.1H30.72C13.75 511.1 0 498.2 0 481.3C0 397.9 63.28 329.3 144.4 320.9L181.9 395.8L201.8 336H191.1C183.2 336 175.1 328.8 175.1 320C175.1 311.2 183.2 304 191.1 304H256zM224 479.1L245.9 436.2L224 370.6L202.1 436.2L224 479.1zM415.1 479.1C415.4 421.2 375.6 371.8 321.4 356.7L259.8 479.1H415.1zM188.2 479.1L126.6 356.7C72.43 371.8 32.58 421.2 32.01 479.1H188.2z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgexport9);
export default __webpack_public_path__ + "static/media/svgexport-9.581941d806b50b24583b045e834f29e8.svg";
export { ForwardRef as ReactComponent };